import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { EvaService } from "../core";
import { AuthenticationService } from "../services/authentication.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private evaService: EvaService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // need to relog on 403
        if (err.status == 403 && request.url.includes("employees/me") && !this.authenticationService.isLoggingOut) {
          this.authenticationService.logout();
          location.reload();
        }

        // Erreur réseau (connexion perdue, timeout, serveur injoignable)
        // err.error est un ProgressEvent non-sérialisable quand status === 0
        if (err.status === 0) {
          const networkError = new Error("Erreur réseau : vérifiez votre connexion internet");
          networkError.name = "NetworkError";
          return throwError(() => networkError);
        }

        // Erreur serveur (5xx) → toast utilisateur + marquage pour filtrage Sentry
        if (err.status >= 500) {
          this.evaService.showWarning("Une erreur serveur est survenue. Réessayez dans quelques instants.");
          const serverError = new Error(`Server error ${err.status}: ${this.extractMessage(err)}`);
          serverError.name = "ServerError";
          return throwError(() => serverError);
        }

        return throwError(() => err.error);
      }),
    );
  }

  private extractMessage(err: HttpErrorResponse): string {
    const body = err.error;
    if (!body) return err.statusText || "Unknown";
    if (typeof body === "string") return body;
    return body.detail || body.message || body.error || JSON.stringify(body);
  }
}
